let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtL6y")).then(() => parcelRequire('7lu1B'));